import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';
import { ProductPublicModels } from '@features/products/product';

export const getCampaignUseCase = (store: Store, product: ProductPublicModels.PublicProduct): Observable<string> => {
    // TO REFACTOR: Get the store details as a parameter would reduce the coupling and complexity of this function
    return store.select(getCmsConfigValue('related_products_campaign')).pipe(
        map(value => value || product?.reference?.split('-')[1])
    );
};
